import React from "react";
import { Icon } from "@amzn/awsui-components-react-v3";
import styles from "./orphanTeam.module.css";

export const OrphanTeam = (): JSX.Element => {
  return (
    <span
      className={`awsui-util-status-inactive ${styles["no-breadcrumbs-label"]}`}
    >
      <Icon name="status-in-progress" /> Team path is still being created. Try
      again later.
    </span>
  );
};

export default OrphanTeam;
